import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    IDiscount,
    IDiscountCreate,
    IDiscountResponse,
    IEntityState,
    IDiscountDetail,
    DiscountsState
} from "../../../types/discount/discountInterfaces";

/**
 * Estado inicial para la creación de descuentos.
 */
export const initialStateForm: IDiscountCreate = {
    id: 0,
    name: "",
    description: "",
    percentage: 0,
    startDate: "",
    endDate: "",
    status: true,
    productIds: []
};

/**
 * Estado inicial para el descuento seleccionado.
 */
const initialStateDiscountSelected: IDiscountDetail = {
    id: 0,
    name: "",
    description: "",
    type: "PERCENTAGE", // Valor por defecto válido
    discountPercentage: 0,
    discountAmount: 0,
    startDate: "",
    endDate: "",
    status: false,
    products: [],
  };
  

export const initialState: DiscountsState = {
    discounts: [],
    paginator: null,
    discountSelected: initialStateDiscountSelected,
    pageSize: 5,
};

export const discountSlice = createSlice({
    name: "discounts",
    initialState,
    reducers: {
        /**
         * Carga los descuentos en el estado con paginación.
         */
        loadingDiscounts: (state, action: PayloadAction<{ content: IDiscount[] }>) => {
            state.discounts = action.payload.content;
            state.paginator = action.payload;
        },

        /**
         * Cambia el estado activo/inactivo de un descuento.
         */
        toggleDiscountState: (state, action: PayloadAction<IEntityState>) => {
            const { id, status } = action.payload;
            state.discounts = state.discounts.map((discount) =>
                discount.id === id ? { ...discount, status } : discount
            );
        },

        /**
         * Selecciona un descuento para edición o visualización.
         */
        onSelectedDiscount: (state, action: PayloadAction<IDiscountDetail>) => {
            state.discountSelected = action.payload;
        },

        /**
         * Actualiza un descuento en la lista.
         */
        updateDiscount: (state, action: PayloadAction<IDiscount>) => {
            state.discounts = state.discounts.map((discount) =>
                discount.id === action.payload.id ? { ...discount, ...action.payload } : discount
            );
        },

        /**
         * Cambia el tamaño de la paginación.
         */
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },

        /**
         * ✅ Guarda la información detallada de un descuento.
         */
        setDiscountDetail: (state, action: PayloadAction<IDiscountDetail>) => {
            state.discountSelected = {
                id: action.payload.id,
                name: action.payload.name,
                description: action.payload.description,
                type: action.payload.type,
                discountPercentage: action.payload.discountPercentage,
                discountAmount: action.payload.discountAmount,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                status: action.payload.status,
                products: action.payload.products,
              };
        },
    },
});

export const {
    loadingDiscounts,
    toggleDiscountState,
    onSelectedDiscount,
    setPageSize,
    updateDiscount,
    setDiscountDetail,
} = discountSlice.actions;

export default discountSlice.reducer;
